import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Loader2, AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { apiClient } from '../App';

const JoinRedirect = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const resolveCode = async () => {
      try {
        const response = await apiClient.get(`/j/${code}`);
        if (cancelled) return;
        const redirectPath = response.data?.redirect_path;
        if (redirectPath) {
          navigate(redirectPath, { replace: true });
          return;
        }
        setError(true);
      } catch {
        if (!cancelled) setError(true);
      }
    };

    if (code) {
      resolveCode();
    } else {
      setError(true);
    }

    return () => {
      cancelled = true;
    };
  }, [code, navigate]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-zinc-100 px-6">
        <div className="max-w-sm rounded-3xl bg-white p-8 text-center shadow-xl">
          <AlertCircle className="mx-auto mb-5 h-12 w-12 text-zinc-300" />
          <h1 className="mb-2 text-2xl font-bold text-zinc-950">Link Not Found</h1>
          <p className="mb-6 text-sm text-zinc-500">This OpenRuns join link may be expired or incorrect.</p>
          <Button onClick={() => navigate('/dashboard')} className="h-12 rounded-xl bg-zinc-950 px-6 text-white hover:bg-zinc-800">
            Browse Runs
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-100">
      <div className="text-center">
        <Loader2 className="mx-auto mb-3 h-8 w-8 animate-spin text-orange-500" />
        <p className="text-sm font-medium text-zinc-600">Opening run...</p>
      </div>
    </div>
  );
};

export default JoinRedirect;
